import { Helpers } from '../../helpers';
import { IProjectTemplate } from '../../interfaces/iproject-template';
import { AssetTeam } from '../asset-team';
import { ConstructionType } from '../construction-type';
import { Division } from '../division';
import { DrillDesign } from '../drill-design';
import { Employee } from '../employee';
import { Function } from '../function';
import { OperatingUnit } from '../operating-unit';
import { ProjectSubType } from '../project-sub-type';
import { ProjectTemplateRateTable } from '../project-template-rate-table';
import { ProjectType } from '../project-type';
import { ScheduleTemplateName } from '../schedule-template-name';
import { StandardConfiguration } from '../standard-configuration';

export class ProjectTemplateBase {
  ProjectTemplateId: number;
  ProjectTypeId: number | null;
  ProjectSubTypeId: number | null;
  DefaultStandardConfigurationId: number | null;
  AssetTeamId: number | null;
  DivisionId: number | null;
  FunctionId: number | null;
  ExploreDevelopId: number | null;
  DrillDesignId: number | null;
  ScheduleTemplateNameId: number | null;
  OperatingUnitId: number | null;
  OwnerEmployeeId: number | null;
  Name: string | null;
  Description: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  ConstructionTypeId: number | null;

  ProjectTemplateRateTables_ProjectTemplate?: Array<ProjectTemplateRateTable> | null;
  AssetTeam?: AssetTeam;
  ConstructionType?: ConstructionType;
  Division?: Division;
  DrillDesign?: DrillDesign;
  Function?: Function;
  OperatingUnit?: OperatingUnit;
  ProjectSubType?: ProjectSubType;
  ProjectType?: ProjectType;
  ScheduleTemplateName?: ScheduleTemplateName;
  StandardConfiguration?: StandardConfiguration;
  Employee?: Employee;

  constructor(item?: IProjectTemplate) {
    if (item) {

      this.ProjectTemplateId = item.ProjectTemplateId;
      this.ProjectTypeId = item.ProjectTypeId;
      this.ProjectSubTypeId = item.ProjectSubTypeId;
      this.DefaultStandardConfigurationId = item.DefaultStandardConfigurationId;
      this.AssetTeamId = item.AssetTeamId;
      this.DivisionId = item.DivisionId;
      this.FunctionId = item.FunctionId;
      this.DrillDesignId = item.DrillDesignId;
      this.ScheduleTemplateNameId = item.ScheduleTemplateNameId;
      this.OperatingUnitId = item.OperatingUnitId;
      this.OwnerEmployeeId = item.OwnerEmployeeId;
      this.Name = item.Name;
      this.Description = item.Description;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.ConstructionTypeId = item.ConstructionTypeId;

      this.ProjectTemplateRateTables_ProjectTemplate = Helpers.createClassArray(ProjectTemplateRateTable, item.ProjectTemplateRateTables_ProjectTemplate);
      this.AssetTeam = new AssetTeam(item.AssetTeam);
      this.ConstructionType = new ConstructionType(item.ConstructionType);
      this.Division = new Division(item.Division);
      this.DrillDesign = new DrillDesign(item.DrillDesign);
      this.Function = new Function(item.Function);
      this.OperatingUnit = new OperatingUnit(item.OperatingUnit);
      this.ProjectSubType = new ProjectSubType(item.ProjectSubType);
      this.ProjectType = new ProjectType(item.ProjectType);
      this.ScheduleTemplateName = new ScheduleTemplateName(item.ScheduleTemplateName);
      this.StandardConfiguration = new StandardConfiguration(item.StandardConfiguration);
      this.Employee = new Employee(item.Employee);
    }
  }
}